<template>
  <v-container fluid px-4 ma-0 class="timeline-on-grey">
    <CaseConfigHeader
        header="My Activity"
        subheader="A timeline of all your interactions with data in Caseblocks."
    ></CaseConfigHeader>
    <Loading :isLoading="isCurrentUserLoading">
      <UserEvents></UserEvents>
    </Loading>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Loading from "@/components/shared/Loading.vue"
import UserEvents from '@/components/homepage/UserEvents.vue'
import Vue from 'vue'
import CaseConfigHeader from "@/components/cases/case-config/CaseConfigHeader.vue";

export default {
  name: "dashboard-timeline",
  mounted() {
    Vue.store.dispatch('setPageTitle', "My Activity")
  },
  components: {
    UserEvents,
    Loading,
    CaseConfigHeader
  },
  computed: mapState({
    currentUser: state => state.currentUser,
    isCurrentUserLoading: state => state.currentUser.isCurrentUserLoading,
    section: state => state.route.params.section
  }),
  methods: {
    welcome() {
      return `Welcome back ${this.currentUser.me.displayName}`
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.store.dispatch("setupTimeline", { timelineType: "user" })
    next()
  }
}
</script>
